export default "__VITE_ASSET__C29$VxqY__"